import module from 'finanzas/module.js'
import template from './template.html'

module.config(($dialogProvider) => {
  $dialogProvider.dialog('finances.tablaRelacional.set', {
    controller: 'FinancesTablaRelacionalSetController',
    template,
    controllerAs: '$ctrl',
  })
})

class FinancesTablaRelacionalSetController {
  constructor ($dialogParams, dialog, FinanzasTablaRelacional) {
    this.$dialogParams = $dialogParams
    this.dialog = dialog
    this.FinanzasTablaRelacional = FinanzasTablaRelacional
  }

  $onInit () {
    this.data = Object.assign({
      ID_Relacional: '',
      Nombre_Largo: '',
      Status: '1',
    }, this.$dialogParams['data'])
  }

  cancel () {
    this.dialog.reject()
  }

  set () {
    this.saving = true
    this.FinanzasTablaRelacional.set(
      this.$dialogParams['ID_Empleado'],
      this.$dialogParams['ID_Empresa'],
      this.$dialogParams['ID_Relacional'],
      this.$dialogParams['Nombre_Largo'],
      this.data,
      )
      .then(() => (this.dialog.resolve(this.data)))
      .finally(() => (this.saving = false))
  }
}

module.controller('FinancesTablaRelacionalSet', FinancesTablaRelacionalSetController)



// WEBPACK FOOTER //
// ./src/finanzas/_/tablaRelacional/set/finances-tablaRelacional-set.js